
    export default {
        name: 'ServicesInformation',
        props: {
            template: {
                type: String,
                required: true,
            },
            aboutPage: {
                type: Array,
                default: Array,
            },
        },
        methods: {
            scrollToContactForm() {
                document.getElementById('contact-information').scrollIntoView(
                    {
                        behavior: 'smooth',
                        block: 'nearest',
                    },
                );
            },
        },
    };
